import React from "react";
import { RouteProps, useLocation } from "react-router-dom";
import { useSupportChat } from "shared-hooks";
import config from "config/global";

export default function withSupportChat<P extends RouteProps>(
  WrappedComponent: React.ComponentType<RouteProps>
) {
  return function (props: P) {
    const location = useLocation();
    useSupportChat(location.pathname, undefined, config.supportChatBotId);

    return <WrappedComponent {...props} />;
  };
}
